import { render } from "./OwnerDetails.vue?vue&type=template&id=44daa1c7&ts=true"
import script from "./OwnerDetails.vue?vue&type=script&lang=ts"
export * from "./OwnerDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__